import { render, staticRenderFns } from "./loading-spinner.vue?vue&type=template&id=0ca20e20"
import script from "./loading-spinner.vue?vue&type=script&lang=ts"
export * from "./loading-spinner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports